/**
 * Use this if you want to make a wrapping element clickable
 * Usage:
 * <div class="bg-blue-100 cursor-pointer hover:bg-blue-200" onclick="clickMyChild.call(this, event, 'input[type=checkbox]')">
 *   <input type="checkbox">
 * </div>
 * @param {*} selector 
 */
window.clickMyChild = function(event, selector) {
    if (event.srcElement !== this) { return }
    const element = this.querySelector(selector)
    if (element) { element.click() }
}